<template>
  <span>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      style="box-shadow: 5px 5px 5px #dedede"
    >
      <v-list dense>
        <template v-for="item in items">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              style="text-decoration: none; color: #db0000"
              v-for="(child, i) in item.children"
              :key="i"
              :to="item.link"
              link
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            style="text-decoration: none; color: #db0000"
            v-else
            :key="item.text"
            :to="item.link"
            link
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="#db0000"
      dark
    >
      <div style="width: 16%">
        <v-list-item two-line :class="'px-0'">
          <v-list-item-avatar>
            <img src="../../../public/logo.png" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>Posta Uganda</v-list-item-title>
            <v-list-item-subtitle style="color: #ffffff"
              ><b> ePosta Clients Portal</b></v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
      </div>

      <v-app-bar-nav-icon
        class="fa-pull-left"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <v-menu
        open-on-hover
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon large v-bind="attrs" v-on="on">
            <v-avatar size="35px" item>
              <v-icon dark>mdi-account-circle</v-icon>
            </v-avatar>
          </v-btn>
        </template>

        <v-card>
          <v-list>
            <v-list-item>
              <v-avatar>
                <v-icon large color="#db0000"> mdi-account-circle </v-icon>
              </v-avatar>

              <v-list-item-content>
                <v-list-item-subtitle>{{ username }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list dense>
            <v-list-item-group v-model="item" color="primary">
              <!-- <v-list-item
        >
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item-content>
        </v-list-item>-->

              <v-list-item @click.prevent="onLogout">
                <v-list-item-icon>
                  <v-icon>mdi-logout-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import router from "@/configurations/router";

export default {
  name: "Dashboard",
  props: {
    source: String,
  },
  data: () => ({
    username: null,
    dialog: false,
    drawer: null,
    items: [
      { icon: "mdi-cube-outline", text: "Boxes", link: "/dashboard/boxes" },
      {
        icon: "mdi-autorenew",
        text: "Box Renewal",
        link: "/dashboard/box-renewal",
      },
      { icon: "mdi-cash", text: "Pay Arrears", link: "/dashboard/pay-arrears" },
      // { icon: 'mdi-account-edit', text: 'Apply For a Box', link: '/dashboard/apply-box' },
      { icon: "mdi-email-outline", text: "Mail", link: "/dashboard/mail" },
      {
        icon: "mdi-truck-delivery",
        text: "Delivery",
        link: "/dashboard/delivery",
      },
      {
        icon: "mdi-location-exit",
        text: "Track & Trace",
        link: "/dashboard/tracking",
      },
      {
        icon: "mdi-room-service-outline",
        text: "Services",
        link: "/dashboard/services",
      },
      {
        icon: "mdi-bank-outline",
        text: "Transactions",
        link: "/dashboard/transactions",
      },
      /*
      { icon: 'mdi-history', text: 'Frequently contacted' },
      { icon: 'mdi-content-copy', text: 'Duplicates' },
      {
        icon: 'mdi-chevron-up',
        'icon-alt': 'mdi-chevron-down',
        text: 'Labels',
        model: true,
        children: [
          { icon: 'mdi-plus', text: 'Create label' },
        ],
      },
      {
        icon: 'mdi-chevron-up',
        'icon-alt': 'mdi-chevron-down',
        text: 'More',
        model: false,
        children: [
          { text: 'Import' },
          { text: 'Export' },
          { text: 'Print' },
          { text: 'Undo changes' },
          { text: 'Other contacts' },
        ],
      },
      { icon: 'mdi-cog', text: 'Settings' },
      { icon: 'mdi-message', text: 'Send feedback' },
      { icon: 'mdi-help-circle', text: 'Help' },
      { icon: 'mdi-cellphone-link', text: 'App downloads' },
      { icon: 'mdi-keyboard', text: 'Go to the old version' },*/
    ],
  }),
  mounted() {
    document.title = "Dashboard | ePosta User";

    let req = {
      client_id: this.getClientId,
    };

    if (localStorage.getItem("eposta_account") == null) {
      this.fetchAccountInfo(req);
      this.username = this.getAccount.name;
    } else {
      this.username = JSON.parse(localStorage.getItem("eposta_account")).name;
    }
  },

  computed: {
    ...mapGetters(["getAccount", "getClientId"]),
    currentPage() {
      return this.$route.path;
    },
  },
  methods: {
    ...mapActions(["fetchAccountInfo"]),
    onLogout: function () {
      localStorage.clear();
      router.push("/home");
      router.go();
    },
    showDashboard: function (id) {
      document.getElementById("#" + id).classList.add("active");
    },
  },
};
</script>

<style scoped></style>
